<template>
  <div class="athletes_photos">
    <header
      class="fonts_color headers"
      style="text-align: center;padding: 44px 0;color: #444;font-weight: 600;margin:0;"
    >
      <h1
        style="font-size: 24px;margin:0 0 14px;padding:0"
      >{{details.matchName?details.matchName:matchName}}</h1>
      <h2 style="font-size: 22px;padding:0;margin:0">{{userInfo.schoolName}}大学生参赛运动员</h2>
    </header>
    <template v-if="details.athleteList && details.athleteList.length > 0">
      <template v-for="item in getShowNum">
        <div class="rows" :key="item" :style="{pageBreakAfter:item % 4 === 0?'always':''}" :class="[item !== 1 && item % 4 === 1?'margin_top':'']">
          <div class="top" style="width:100%;display:flex">
            <div
              class="right_border"
              :style="{borderRight:(index+1) == 5 ?'none':'1px solid #999'}"
              style="width:20%;box-sizing:border-box"
              v-for="(temp,index) in details.athleteList.slice((item - 1) * 5,item * 5)"
              :key="index + '_' + item"
              :class="[index === 0?'left_border':'',item % 4 === 1 || item === 1?'top_border':'',(index + 1) % 5 === 0?'export_pdf_right':'']"
            >
              <div style="display:flex;justify-content:center;align-items:center;">
                <section style="padding:10px;">
                  <img :src="temp.headImage" style="width:160px;height:200px;" alt />
                </section>
              </div>
            </div>
          </div>
          <div class="bottom" style="width:100%;display:flex">
            <div
              class="right_border bottom_border"
              :style="{borderRight:(index+1) == 5 ?'none':'1px solid #999',borderBottom:item === getShowNum?'none':'1px solid #999'}"
              style="width:20%;display:flex;flex-direction:column;justify-content:center;align-items:center;border:1px solid #999;border-left:none;padding:10px;box-sizing:border-box"
              v-for="(temp,index) in details.athleteList.slice((item - 1) * 5,item * 5)"
              :key="index + '-' + item"
              :class="[index === 0?'left_border':'',(index + 1) % 5 === 0?'export_pdf_right':'',item === getShowNum?'export_pdf_bottom':'']"
            >
              <p class="athlete_info fonts_color" style="margin:0 0 10px;font-size:18px;color:#444;display:flex;padding:0;">
                <span style="margin-right:16px">{{temp.signNumber}}</span>
                <span style="max-width:140px;">{{temp.athleteName}}</span>
              </p>
              <p style="margin:0;padding:0;">{{temp.registerNumber}}</p>
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div
        style="height:200px;display:flex;align-items:center;justify-content:center;font-size:24px"
      >暂无数据</div>
    </template>
  </div>
</template>
<script>
import { getSession } from "@/utils/storage.js";
export default {
  props: {
    details: {
      type: Object
    },
    matchName: {
      type: String
    }
  },
  data() {
    return {
      isRenders:false,
      userInfo: JSON.parse(getSession("userInfo")) || ""
    };
  },
  computed: {
    getShowNum() {
      let num = 0;
      if (this.details.athleteList && this.details.athleteList.length < 5) {
        num = 1;
      } else if (
        this.details.athleteList &&
        this.details.athleteList.length >= 5
      ) {
        let length = this.details.athleteList.length;
        if (length / 5 > parseInt(length / 5)) {
          num = parseInt(length / 5) + 1;
        } else {
          num = length / 5;
        }
      }
      return num;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isRenders = true;
    });
  }
};
</script>
<style lang="less" scoped>
.athletes_photo {
  border: 1px solid #999;
  width: 1050px;
  margin: 0 auto;
  > header {
    text-align: center;
    padding: 44px 0;
    color: #444;
    font-weight: 600;
    border-bottom: 1px solid #999;
    > h1 {
      font-size: 24px;
      margin-bottom: 14px;
    }
    > h2 {
      font-size: 22px;
    }
  }
}
.top_border {
    border-top:1px solid #999;
}
</style>